export const UNIT_SALE_TYPE = 1;
export const UNIT_COUNTER_PATTERN = 2;
export const UNIT_STORE_SPECIFIC = 3;
export const UNIT_ALL_STORE = 4;

export const UNIT = [
  // { value: UNIT_SALE_TYPE, name: '販売タイプ' },
  { value: UNIT_COUNTER_PATTERN, name: 'レジパターン' },
  { value: UNIT_STORE_SPECIFIC, name: '店舗指定' },
  { value: UNIT_ALL_STORE, name: '全店' },
];

export const DELIVERY_STATUS_ALL = '-1';
export const DELIVERY_STATUS_UNSENT = 1;
export const DELIVERY_STATUS_FAILED = 2;
export const APPROVAL_STATUS_ALL = '-1';

export const STATUS_RESPONSE_SUCCESS = 'success';
export const STATUS_RESPONSE_FAILED = 'failed';
export const STATUS_RESPONSE_PROGRESSING = 'progressing';
export const STATUS_RESPONSE_COMPLETED = 'completed';

export const UNIT_TEST_REFLECTION = [{ value: UNIT_STORE_SPECIFIC, name: '店舗指定' }];
export const TARGET_SCHEMA_DEFAULT = { target_schema: 'public', name: '現行データ' };

export const REEDIT_STATUS_HAVE_NO_SCHEMA = 0;
export const REEDIT_STATUS_SCHEMA_CREATING = 1;
export const REEDIT_STATUS_SCHEMA_READY = 2;

export const APPROVAL_STATUS_NEW = 'NEW';
export const APPROVAL_STATUS_APPLYING = 'APPLYING';
export const APPROVAL_STATUS_CONFIRMED = 'CONFIRMED';
export const APPROVAL_STATUS_APPROVED = 'APPROVED';
export const APPROVAL_STATUS_REJECTED = 'REJECTED';
export const APPROVAL_STATUS_DELETED = 'DELETED';

export const ASYNC_TASK_POLL_INTERVAL_MS = 3000;
export const ASYNC_TASK_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes
